var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isInitialized)?_c('a',{class:_vm.buttonClass,on:{"click":function($event){return _vm.startImport()}}},[_c('img',{attrs:{"src":"/assets/icons/csv-icon.png"}}),_vm._v("\n  Upload CSV File\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }